import { BaseComponent } from '../../base-component';

export class BreadcrumbComponent extends BaseComponent {
    public readonly rootSelector: string = '.js_pdp_breadcrumb';
    private initialHtmlLoaded: boolean = true;

    public async onHtmlLoaded(): Promise<void> {
        if (this.initialHtmlLoaded) {
            this.initialHtmlLoaded = false;
            return;
        }
        return o_global.eventQBus.emit('ftnav.breadcrumb.register');
    }
}
